import React, { useRef, useState } from "react";
import "./assests/css/style.css";
import imgurl from "./assests/images/imgurl";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';

function Onboarding() {
  const navigate = useNavigate();
  const goNext = () => {
    navigate("/loginpage");
  };

  return (
    <div className="onboarding">
      <div className="carouselcontainer">
        <div key={1}>
          <div className="beginsecimg">
            <div className="loginpglogo d-none">
              <img src={imgurl.alopexiaLogoBlue} alt="New Logo" className='mainlogo'/>
            </div>
            <div className="onboarding-msgs">
              <Typography className="onboardingtxtone">
                Personalised Hair{" "}
              </Typography>
              <Typography className="onboardingtxtone">
                Restoration Starts Here
              </Typography>
            </div>
          </div>

          <div className="beginsection">
            {/* <p className="firstext">
              Hair Restoration <br /> Medicine
            </p>
            <p className="secondtext">
              Hair Loss Expert takes a personalised approach to hair loss treatment,
              tailoring each formula to meet the unique needs of individual
              patients.
            </p> */}

            <div className="loginpglogo ">
              <img src={imgurl.alopexiaLogoBlue} alt="New Logo" className='mainlogo'/>
            </div>

            <div className="service-checklist">
              <div className="services">
                <img src={imgurl.checkmark} alt="Check Icon" />
                <Typography>AI Powered Hair & Health Assessment</Typography>
              </div>
              <div className="services">
                <img src={imgurl.checkmark} alt="Check Icon" />
                <Typography>
                  Personalised Hair Restoration Solutions{" "}
                </Typography>
              </div>
              <div className="services">
                <img src={imgurl.checkmark} alt="Check Icon" />
                <Typography> Expert Guidance at Every Step</Typography>
              </div>
            </div>

            <div className="linkbtnsec">
              <Button
                variant="contained"
                onClick={() => goNext()}
                className="commonButton"
              >
                Get Started
              </Button>
              {/* <Button
                variant="contained"
                onClick={() => navigate("/productdetls")}
                className="commonButton"
              >
                Product Page
              </Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Onboarding;
